module.exports = {
      id: "pinterest.-circle-colorsvg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-b11c226f9ecc9a258e9645c9abf2e2fd.svg#pinterest.-circle-colorsvg",
      toString: function () {
        return this.url;
      }
    }